import Theme from '@jetbrains/ring-ui/components/global/theme'

export const getCurrentTheme = (): Theme => {
  const darkMatcher = window.matchMedia('(prefers-color-scheme: dark)')
  return darkMatcher.matches ? Theme.DARK : Theme.LIGHT
}
